import styles from "./InfoPage.module.scss"; // Імпортуємо SCSS файл для стилів
import Nav from "@/components/Header/Nav/Nav";
import Footer from "@/components/Footer/Footer";
import CookiePopupButton from "@/components/CookieBanner/CookiePopupButton.tsx";
import { useEffect } from "react";

const PaymentSuccess = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Скролимо в верх сторінки
  }, []);

  return (
    <div>
      <title>
        Zahlung erfolgreich – HIXA – DSG Getriebe Reparatur & Wartung
      </title>
      <link rel="icon" href="/images/favicon.ico" type="image/x-icon" />
      <Nav />
      <h2 className={` sectionContainer ${styles.title}`}>
        Zahlung erfolgreich
      </h2>
      <div className="container sectionContainer sectionContainerWhite">
        <p className={styles.infoPageText}>
          Vielen Dank für Ihre Zahlung! Ihre Transaktion wurde erfolgreich
          abgeschlossen.
          <br />
          Wir bearbeiten Ihre Bestellung und Sie erhalten in Kürze eine
          Bestätigung.
        </p>

        <p className={styles.infoPageText}>
          Falls Sie Fragen haben, zögern Sie nicht, uns zu kontaktieren:
          <br />
          Telefon: +49 30 520 151 91
          <br />
          E-Mail: kunden@hixa.eu
        </p>
      </div>
      <CookiePopupButton />
      <Footer />
    </div>
  );
};

export default PaymentSuccess;
